import { createStore } from 'vuex'
export default createStore({
  state: {
    token: localStorage.getItem('qlzx_monitoring_api_token'),
    //用于判断弹出框的次数 只弹一次
    second: 0,
    selectTab_item: ''
  },
  mutations: {
    zeng(state) {
      state.second++;
    },
    gorouter(state,name) {
       state.selectTab_item = name
    }
  },
  actions: {
  },
  modules: {
  }
})

